import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../config/https";
import { useLoader } from "../../context/LoaderContext";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { FREELANCER } from "../../Router/paths";

export default function MyProposalsComp() {
  const { startLoader, stopLoader } = useLoader();
  const [proposals, setProposals] = useState(0);

  useEffect(() => {
    const getProfile = () => {
      startLoader();
      axiosInstance
        .get("/api/job-proposals/")
        .then((resp) => {
          stopLoader();
          const Data = resp.data;
          if (resp.status === 200 || resp.status === 201) {
            setProposals(Data?.data?.length || 0);
          } else {
            toast.warning(Data.msg);
          }
        })
        .catch(() => {
          stopLoader();
        });
    };
    getProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <section className="my-proposals pc-p-3">
      <div className="container">
        <div className="primary-heading color-dark mb-3">
          <h4>My Proposals</h4>
        </div>
        {/* <div className="proposals-box mb-3">
          <a href="javascript:void(0)">
            {" "}
            <h4>
              Active proposals (0){" "}
              <img src="/assets/question-ico.png" alt="Question Icon" />
            </h4>{" "}
          </a>
        </div> */}
        <div className="proposals-box">
          <Link to={FREELANCER.viewProposals}>
            {" "}
            <h4>
              Submitted proposals ({proposals}){" "}
              <img src="/assets/question-ico.png" alt="Question Icon" />
            </h4>{" "}
          </Link>
        </div>
      </div>
    </section>
  );
}
